export const CART_LOADING = "LOADING/CART";
export const CART_ERROR = "ERROR/CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const GET_CART_Items = "GET_CART_Items";
export const CHANGE_CART_QTY = "CHANGE_CART_QTY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
